import React from 'react';
import { Spin } from 'antd';
import Styles from './LoadingState.module.scss';

interface LoadingStateProps {
    /** Loading message/tip */
    tip?: string;
    /** Size of the spinner */
    size?: 'small' | 'default' | 'large';
    /** Custom className */
    className?: string;
    /** Full height container */
    fullHeight?: boolean;
    /** Custom message text */
    message?: string;
}

/**
 * Reusable loading state component with centered spinner
 */
export default function LoadingState({
    tip,
    size = 'large',
    className,
    fullHeight = false,
    message,
}: LoadingStateProps) {
    const containerClass = `${Styles.container} ${fullHeight ? Styles.fullHeight : ''} ${className || ''}`.trim();

    return (
        <div className={containerClass}>
            <Spin size={size} />
            {(message || tip) && <div className={Styles.message}>{message || tip}</div>}
        </div>
    );
}
